import React, { useState } from "react";
import {
    Table, TableBody, TableCell, TableHead, TableRow, Card, Box, Button,
    TextField, MenuItem, Select, FormControl, InputLabel, Grid, Paper
} from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckIcon from "@material-ui/icons/CheckCircle";
import StarIcon from "@material-ui/icons/Star";
import WarningIcon from '@material-ui/icons/Warning';

// import DevelopingIcon from "@material-ui/icons/TipsAndUpdates";
import AttentionIcon from "@material-ui/icons/ReportProblem";
import ErrorIcon from '@material-ui/icons/Error';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import SubActivityService from "./Locality/Service/subActivityService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import PageTitle from "../../components/PageTitle/PageTitle";
import { useEffect } from 'react';
import ActivityService from "./Locality/Service/activityService";
import SuperActivityService from "./Locality/Service/superActivityService"
import StudentService from "./Locality/Service/studentService"
const statuses = ["P", "WA", "WI", "M"]; // Presented, Work with Assistance, etc.
const statusLabels = {
    P: "Presented",
    WA: "Works with Assistance",
    WI: "Works Independently",
    M: "Mastered",
};

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));

export default function ActivityAnalysis() {
    const classes = useStyles();
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    const [allSuperActivities, setAllSuperActivities] = useState([]);

    const [activityList, setActivityList] = useState([]);
    const [studentsList, setstudentsList] = useState([]);
    const [classId, setClassId] = useState("");
    const [sectionId, setSectionId] = useState("");
    const [sectionList, setSectionList] = useState([]);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    var [isLoading, setIsLoading] = useState(false);
    const [addClassList, setAddClassList] = useState([]);
    var [studentId, setStudentId] = useState("");
    const [selectedKey, setSelectedKey] = useState("");
    const keyOptions = [
        { label: 'Strong area', value: 'M,WI' },
        { label: 'Developing area', value: 'WA' },
        { label: 'Needs attention', value: 'P' },
    ];
    const [activeTab, setActiveTab] = useState('');
    
    useEffect(() => {
        getAddClassList();



        return () => {
            setStudentList([]);
            setAddSuperActivityList([]);
            setActivityList([]);
        }
    }, []);
    const colorMap = {
        "P": "#5C9882",
        "WI": "#E6B163",
        "WA": "#A75C9C",
        "M": '#147ad482'
    };
    
    const transformActivityData = (data) => {
  const result = {};
  data.forEach(item => {
    if (["M", "WI", "WA", "P","Future Plane"].includes(item._id)) {
      result[item._id] = item.activities;
    }
  });
  return result;
};

    const onSubmit = (data) => {
        setIsLoading(true); 
        const keys = {
            schooleId: userDetails.schooleId,
            isFuturePlanning: false,
            studentId: studentId,
            classId: classId,
            sectionId: sectionId || userDetails.sectionId || undefined,
        };

        ActivityService.findActivityAnalysisReportsList(keys)
            .then((result) => {
                setActivityList(transformActivityData(result));

              
               
             

            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setIsLoading(false); // End loading
            });
    };

    const getAddClassList = () => {
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            let list = res;
            if (userDetails.role === "TEACHER" && userDetails.classId) {
                list = res.filter(item => item._id === userDetails.classId);
            }
            setAddClassList(list);

            if (userDetails.role === "TEACHER" && userDetails.classId) {
                const selectedClassId = userDetails.classId;
                const teacherSectionId = userDetails.sectionId || "";
                setClassId(selectedClassId);
                setSectionId(teacherSectionId);
                getSectionListByClass(selectedClassId);
                getStudentList({ target: { value: selectedClassId } }, teacherSectionId || undefined);
                getSuperActivityList(selectedClassId);
            } else if (list.length > 0) {
                const defaultClassId = list[0]._id;
                setClassId(defaultClassId);
                setSectionId("");
                getSectionListByClass(defaultClassId);
                getSuperActivityList(defaultClassId);
                getStudentList({ target: { value: defaultClassId } });
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }

    const getSectionListByClass = (selectedClassId) => {
        if (!selectedClassId) {
            setSectionList([]);
            setSectionId("");
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId: selectedClassId,
        }).then((res) => {
            let list = Array.isArray(res) ? res : [];
            if (userDetails.role === "TEACHER" && userDetails.sectionId) {
                list = list.filter(
                    (s) => String(s._id) === String(userDetails.sectionId)
                );
            }
            setSectionList(list);
            if (userDetails.role === "TEACHER" && userDetails.sectionId && list.length > 0) {
                setSectionId(userDetails.sectionId);
            }
        }).catch(() => {
            setSectionList([]);
        });
    };

    const getSuperActivityList = async (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        try {
            const res = await SuperActivityService.getAllSuperActivityById(userDetails.schooleId, { classId: classId });
            setAllSuperActivities(res); // Save all to filter later

            // Initial filter (if classId already set)
            if (classId) {
                const filtered = res.filter(item => item.classId?._id === classId);
                setAddSuperActivityList(filtered);
                if (filtered.length > 0) {
                    setActiveTab(filtered[0]._id);
                  //  onSubmit(filtered[0]._id);
                }
            }
        } catch (err) {
            console.error(err);
        }
    };
    // const getSuperActivityList = async ( classId) => {
    //         const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //         try {
    //             const res = await SuperActivityService.getAllSuperActivityById(userDetails.schooleId, { classId: classId });
    //             setAddSuperActivityList(res);

    //             if (res.length > 0) {
    //                 setActiveTab(res[0]._id);
    //                 onSubmit(res[0]._id,  classId);
    //             }
    //         } catch (err) {
    //             console.error(err);
    //         }
    //     };

    const getStudentList = (event, overrideSectionId) => {
        const selectedClassId = event?.target?.value || classId;
        const body = { classId: selectedClassId };
        const effectiveSectionId =
            overrideSectionId !== undefined
                ? overrideSectionId
                : sectionId || userDetails.sectionId || undefined;
        if (effectiveSectionId) {
            body.sectionId = effectiveSectionId;
        }

        StudentService.getAllStudentById(userDetails.schooleId, body)
            .then((res) => {
                const studentDetails = res.map((student) => ({
                    _id: student._id,
                    studentName: `${student.firstName} ${student.lastName}`,
                    status: true,
                }));
                setStudentList(studentDetails);
            })
            .catch((err) => {
                console.error("Error fetching students:", err);
            });
    };

    const handleTabClick = (superActivityId) => {

        setActiveTab(superActivityId);
        onSubmit(superActivityId);
    };
    const getStudentReportList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        if (studentId == '') {
            alert("Please Select Student");
            return;
        }
        const getstudentId = { "studentId": studentId, };

        SubActivityService.getStudentReport(getstudentId).then((res) => {
            // const blob = new Blob(res.pdfBuffer);
            const buffer = Buffer.from(res.pdfBuffer);
            const blob = new Blob([buffer]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "studentreport.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
            // const blob = new Blob([res.pdfBuffer]);
            // saveAs(blob, 'filename.pdf');
            // const file = new File(res.pdfBuffer, 'filename.txt', { type: 'text/plain' });
            // setStudentReportList(res);
        }).catch((err) => {
            alert(err.response.data.message)
        });
    }
    return (

        <Paper style={{ padding: 20 }}>
            <PageTitle title="Activity  Analysis" />
            <Card sx={{ maxWidth: 345 }}>
                <Box style={{ margin: 15, }} >


                    <Grid container spacing={2} columns={12} style={{ margin: 10, }}  >
                        <Grid item xs={12} sm={6} md={3}  >
                            <FormControl className={classes.formControl} style={{ width: 220 }}
                            >
                                <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="classId"
                                    label="selectClass"

                                    onChange={e => {
                                        const selectedClassId = e.target.value;
                                        setClassId(selectedClassId);
                                        setSectionId("");
                                        getSectionListByClass(selectedClassId);
                                        getStudentList(e); // fetch students for selected class

                                        // Filter super activities for selected class
                                        const filtered = allSuperActivities.filter(
                                            item => item.classId?._id === selectedClassId
                                        );
                                        setAddSuperActivityList(filtered);
                                        getSuperActivityList(selectedClassId)
                                        if (filtered.length > 0) {
                                            setActiveTab(filtered[0]._id);
                                           // onSubmit(filtered[0]._id);
                                        } else {
                                            setActivityList([]);
                                            setActiveTab("");
                                        }
                                    }}
                                    value={classId}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>

                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}

                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <FormControl className={classes.formControl} style={{ width: 220 }}>
                                <InputLabel id="section-select-label">Select Section (Optional)</InputLabel>
                                <Select
                                    labelId="section-select-label"
                                    id="section-select"
                                    value={sectionId}
                                    onChange={(e) => {
                                        const newSectionId = e.target.value;
                                        setSectionId(newSectionId);
                                        if (classId) {
                                            getStudentList({ target: { value: classId } }, newSectionId || undefined);
                                        }
                                    }}
                                    disabled={!classId || sectionList.length === 0}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {sectionList.map(({ _id, sectionName }) => (
                                        <MenuItem key={_id} value={_id}>
                                            {sectionName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}  >
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="studentName">Student Name</InputLabel>
                                <Select
                                    labelId="studentName"
                                    id="studentName"
                                    label="Student Name"
                                    name="studentId"
                                    value={studentId}
                                    onChange={e => { setStudentId(e.target.value) }}

                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {studentList.map(({ index, _id, studentName }) => (
                                        <MenuItem key={index} value={_id}>{studentName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                       
                        <Grid item xs={12} sm={6} md={2}>
                            <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                type="button"

                                onClick={() => onSubmit(activeTab)} variant="contained"
                            >
                                Search</Button>
                        </Grid>
                    </Grid>



                </Box>
            </Card>
            
   {/* Cards Displaying Activity Count by Category */}
{/* Cards Displaying Activity Names by Category */}
<Grid container spacing={2} style={{ marginTop: 16 }}>
  {/* Strong Areas */}
  <Grid item xs={12} sm={6} md={4}>
    <Card style={{ backgroundColor: "#e8f5e9", padding: 20, height: '100%' }}>
      <h3 style={{ color: "#2e7d32", marginBottom: 10 }}>
        <CheckCircleIcon style={{ verticalAlign: 'middle' }} /> Strong Areas
      </h3>
      <ul>
        {["M", "WI"].flatMap(key =>
          (activityList[key] || []).map((activity, index) => (
            <li key={`${key}-${index}`} style={{ fontSize: 14 }}>
              {activity.activityName || "Unnamed Activity"}
            </li>
          ))
        )}
      </ul>
    </Card>
  </Grid>

  {/* Developing Areas */}
  <Grid item xs={12} sm={6} md={4}>
    <Card style={{ backgroundColor: "#fff8e1", padding: 20, height: '100%' }}>
      <h3 style={{ color: "#ef6c00", marginBottom: 10 }}>
        <WarningIcon style={{ verticalAlign: 'middle' }} /> Developing Areas
      </h3>
      <ul>
        {(activityList["WA"] || []).map((activity, index) => (
          <li key={`WA-${index}`} style={{ fontSize: 14 }}>
            {activity.activityName || "Unnamed Activity"}
          </li>
        ))}
      </ul>
    </Card>
  </Grid>

  {/* Needs Attention */}
  <Grid item xs={12} sm={12} md={4}>
    <Card style={{ backgroundColor: "#ffebee", padding: 20, height: '100%' }}>
      <h3 style={{ color: "#c62828", marginBottom: 10 }}>
        <ErrorIcon style={{ verticalAlign: 'middle' }} /> Needs Attention
      </h3>
      <ul>
        {(activityList["P"] || []).map((activity, index) => (
          <li key={`P-${index}`} style={{ fontSize: 14 }}>
            {activity.activityName || "Unnamed Activity"}
          </li>
        ))}
      </ul>
    </Card>
  </Grid>
</Grid>





        </Paper>
        
        
    );
}





































